import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Row } from 'reactstrap';
import ProductLinks from './common/ProductLinks.jsx';
import IconLinks from './IconLinks.jsx';
import useFetch from './common/useFetch.jsx';
import ResponseErrorMessage from './common/ResponseErrorMessage.jsx';
import ShtuffSkeleton from './skeletons/ShtuffSkeleton.jsx';
import ResponseEmptyMessageMessage from './common/ResponseEmptyMessage.jsx';

/**
 *  Subjects component for DH 2.0
 */
const Subjects = () => {
	const [subjects, setSubjects] = useState(null);
	const isSchoolsDomain = window.location.hostname.split('.')[0] === 'schools';

	const getSubjectsApi = '/internal/dynamic-home-api/Ajax/Ajax.php?action=GetSubjects';
	const { response, loading, error } =  useFetch(getSubjectsApi);

	/**
	 * Sets the subjects open/closed state for mobile view
	 *
	 * @param key
	 */
	const collapseHandler = key => {
		let subjectsState = { ...subjects };

		subjectsState[key].collapsed = !subjectsState[key].collapsed;
		setSubjects(subjectsState);
	};

	/**
	 * Iterates the subjects and generates the Shtuff cards
	 *
	 * @returns {boolean}
	 */
	const generateMyShtuff = () => {
		const hiddenOnSchools = ['College', 'Careers'];

		return subjects !== null && Object.keys(subjects)
			.filter(key => !(isSchoolsDomain && hiddenOnSchools.includes(subjects[key].title)))
			.map((key, item) =>
			<div key={key} className={'col-12 col-md-6 col-lg-4 mb-5 mx-2 subject-card-wrapper dark'}>
				<Card className={'subject-or-classroom'} col={'sm-2'}
				      key={subjects[key].title} data-item={item}>
					<h2 className={'artz display-heading swipe-under text-center pt-2'}>
						{subjects[key].title}
					</h2>
					<Button color={'light'}
					        className={subjects[key].collapsed ?
						        'toggle-on collapse-button btn-lg' :
						        'collapse-button btn-lg'}
					        onClick={()=>collapseHandler(key)}
					        aria-expanded={!!subjects[key].collapsed}
					        aria-label={'Toggle ' + subjects[key].title + ' links'}>See Links
						<i className={'far fa-chevron-down'} aria-hidden="true">
						</i>
					</Button>
					<div
						className={subjects[key].collapsed ?
							'collapsed subject-links' :
							'subject-links' }>
						<IconLinks products={subjects[key].icon_products} title={subjects[key].title} />
						<div className={'supreme-hr'}></div>
						<ProductLinks products={ { ...subjects[key].products } } />
					</div>
				</Card>
			</div>
		);
	};

	/**
	 * Displays the component skeleton or and empty response if data is not available
	 *
	 * @returns {boolean|JSX.Element}
	 */
	const getMyShtuff = () => {
		let myShtuff;

		if (loading) {
			myShtuff = <ShtuffSkeleton version={'v2'} />;
		} else if (subjects !== null && !subjects.length) {
			myShtuff = <ResponseEmptyMessageMessage />;
		} else {
			myShtuff = generateMyShtuff();
		}

		return myShtuff;
	};

	/**
	 * Listens for changes in response state.
	 * setSubjects method called when data is response is ready
	 *
	 */
	useEffect(() => {
		response !== null && setSubjects(response.payload);
	}, [response]);

	return (
		<Row className={'mt-5 shtuff-wrapper'} id={'shtuff'}>
			<Col col={'col-12'}>
				<h2 className={'title-line artz'}>SHTUFF YOU GET</h2>
				<div className={'shtuff'}>
					<Row className={'mt-4 justify-content-center'}>
						{ error !== null ? <ResponseErrorMessage error={error} /> : getMyShtuff() }
					</Row>
				</div>
			</Col>
		</Row>
	);
};

export default Subjects;
